// extracted by mini-css-extract-plugin
var _1 = "NameCell_cell__xr5LA";
var _2 = "NameCell_currentUser__CpkZd";
export { _1 as "cell", _2 as "currentUser" }
